import { z } from 'zod'

export const WEBSITE = 'website'
export const STARTER = 'starter'
export const GROWTH = 'growth'
export const PRO = 'pro'
export const AGENCY = 'agency'

export const tier = z.literal([WEBSITE, STARTER, GROWTH, PRO, AGENCY])

// t('tier.website')
// t('tier.starter')
// t('tier.growth')
// t('tier.pro')
// t('tier.agency')

// export const tiers = Object.values(tier.Enum)

export type Tier = z.infer<typeof tier>
